import {ActionType} from 'redux-promise-middleware';
import SpotUtils from 'utils/spot';
import {CHECKOUT_FETCH_RATES} from '../checkout/checkout-actions';
import {FILTERS_RESET} from '../filters/filters-actions';
import {ROUTER_DATA_LOAD_FULFILLED} from '../router/router-actions';
import {SEARCH_SET_SORT_TYPE} from '../search/search-actions';
import {
    SEARCH_REQUEST_SET_TERM,
    SEARCH_REQUEST_SET_LOCATION,
    SEARCH_REQUEST_UPDATE_TIMES,
} from '../search-request/search-request-actions';
import {
    SPOT_UPDATE_SELECTED,
    SPOT_CHANGE_MULTI_RATE,
    SPOT_GET_TRAVEL_DISTANCE,
    SPOT_GET_AIRPORT_TRAVEL_DISTANCE,
    SPOT_RESET_SELECTED_SPOT,
    SPOT_RESET_SELECTED_RATE,
} from './spot-actions';

const initialState = {
    selected: null,
    previousSelected: null,
    showSpotDetailsModal: false,
};

export default function spot(state = initialState, {type, payload, meta}) {
    switch (type) {
        case SPOT_UPDATE_SELECTED: {
            const {spot: selectedSpot, goToSpotUrl} = payload;

            return {
                ...state,
                selected: selectedSpot ? selectedSpot : null,
                previousSelected: state.selected || selectedSpot,
                showSpotDetailsModal: selectedSpot && !goToSpotUrl,
            };
        }

        case SPOT_CHANGE_MULTI_RATE: {
            const {newRate} = payload;

            return {
                ...state,
                selected: {
                    ...state.selected,
                    selectedRate: newRate,
                },
            };
        }

        case `${SPOT_GET_AIRPORT_TRAVEL_DISTANCE}_${ActionType.Fulfilled}`:
        case `${SPOT_GET_TRAVEL_DISTANCE}_${ActionType.Fulfilled}`: {
            const newState = {
                ...state,
            };
            const {
                distanceInMiles,
                drivingDuration,
                walkingDuration,
                hasTravelDistanceUpdated,
            } = payload[0];

            if (newState.selected) {
                newState.selected = {
                    ...newState.selected,
                    distanceInMiles,
                    drivingDuration,
                    walkingDuration,
                    hasTravelDistanceUpdated,
                };
            }

            return newState;
        }

        case `${CHECKOUT_FETCH_RATES}_${ActionType.Fulfilled}`: {
            return {
                ...state,
                selected: SpotUtils.prepare({
                    spot: {
                        ...state.selected,
                        ...payload.data.data,
                    },
                    rid: meta.rid,
                    searchRequest: meta,
                    timezone: meta.timezone,
                }),
            };
        }

        case ROUTER_DATA_LOAD_FULFILLED: {
            const {
                searchRequest: {pageType, isSearchPage},
                spot: selectedSpot,
            } = payload;

            if (
                (pageType === 'checkout' || pageType === 'facility') &&
                selectedSpot &&
                selectedSpot.selected
            ) {
                return {
                    ...state,
                    selected: selectedSpot.selected,
                };
            } else if (isSearchPage) {
                return state;
            } else {
                return initialState;
            }
        }

        case SPOT_RESET_SELECTED_RATE: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    selectedRate: null,
                },
            };
        }

        case FILTERS_RESET:
        case SEARCH_SET_SORT_TYPE:
        case SEARCH_REQUEST_UPDATE_TIMES:
        case SEARCH_REQUEST_SET_TERM:
        case SEARCH_REQUEST_SET_LOCATION:
        case SPOT_RESET_SELECTED_SPOT: {
            return initialState;
        }

        default:
            return state;
    }
}
